export const hairArray = [
    {id: "1", code: "HAIR_BLACK", detail: "Black"},
    {id: "2", code: "HAIR_COMBO", detail: "Combo"},
    {id: "3", code: "HAIR_BLONDE", detail: "Blonde"},
    {id: "4", code: "HAIR_RED", detail: "Red"},
    {id: "5", code: "HAIR_BROWN", detail: "Brown"},
    {id: "6", code: "HAIR_GREY", detail: "Grey"},
    {id: "7", code: "HAIR_BALD", detail: "Bald"}
  ];
  
  export const relationshipArray = [
    {id: "1", code: "REL_NEVERMARRIED", detail: "Never Married"},
    {id: "2", code: "REL_DIVORCED", detail: "Divorced"},
    {id: "3", code: "REL_WIDOWED", detail: "Widowed"},
    {id: "4", code: "REL_SEPARTED", detail: "Separted"}
  ];

  export const kidsArray = [
    {id: "1", code: "KIDS_YESHOME", detail: "Yes at Home"},
    {id: "2", code: "KIDS_YESNOTHOME", detail: "Yes not at Home"},
    {id: "3", code: "KIDS_YESPARTHOME", detail: "Yes partime at Home"},
    {id: "4", code: "KIDS_NO", detail: "No Kids"}
  ];

  export const wantKidsArray = [
    {id: "1", code: "WANTKIDS_YES", detail: "Yes-Kids are great"},
    {id: "2", code: "WANTKIDS_NO", detail: "No-Kids not planned"},
    {id: "3", code: "WANTKIDS_MAYBE", detail: "Maybe-with the right person"}
  ];

  export const eduationArray = [
    {id: "1", code: "EDU_HIGH", detail: "High School"},
    {id: "2", code: "EDU_ASSOC", detail: "Associate degree"},
    {id: "3", code: "EDU_BACHELORS", detail: "Bachelors degree"},
    {id: "4", code: "EDU_GRAD", detail: "Graduate degree"},
    {id: "5", code: "EDU_PHD", detail: "PHD degree"},
    {id: "6", code: "EDU_SOMECOLLEGE", detail: "Some College"}
  ];

  export const religonArray = [
    {id: "1", code: "REL_BUDDHIST", detail: "Buddhist/Taoist"},
    {id: "2", code: "REL_CATHOLIC", detail: "Christian/Catholic"},
    {id: "3", code: "REL_LDS", detail: "Christian/LDS"},
    {id: "4", code: "REL_PROTESTANT", detail: "Christian/Protestant"},
    {id: "5", code: "REL_JEWISH", detail: "Jewish"},
    {id: "6", code: "REL_ISLAM", detail: "Muslim/Islam"},
    {id: "7", code: "REL_SPIRITUAL", detail: "Spiritual"},
    {id: "8", code: "REL_HINDU", detail: "Hindu"},
    {id: "9", code: "REL_OTHER", detail: "Other"}
  ];

  export const politalArray = [
    {id: "1", code: "POL_VERYCONSER", detail: "Very Conservative"},
    {id: "2", code: "POL_CONSERVATIVE", detail: "Conservative"},
    {id: "3", code: "POL_MIDDLEROAD", detail: "Middle of the road"},
    {id: "4", code: "POL_LIBERAL", detail: "Liberal"},
    {id: "5", code: "POL_VERYLIBERAL", detail: "Very liberal"},
    {id: "6", code: "POL_NOTPOLITICAL", detail: "Not political"}
  ];